import { render, staticRenderFns } from "./ratingsWrapper.vue?vue&type=template&id=54b99cba&scoped=true"
import script from "./ratingsWrapper.vue?vue&type=script&lang=js"
export * from "./ratingsWrapper.vue?vue&type=script&lang=js"
import style0 from "./ratingsWrapper.vue?vue&type=style&index=0&id=54b99cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b99cba",
  null
  
)

export default component.exports